import { AlertTriangle } from 'lucide-react';
import { OnboardingSurface } from './Surface';

interface OrphanOrgAccessPanelProps {
  email?: string;
}

function OrphanOrgAccessPanel({ email }: OrphanOrgAccessPanelProps) {
  return (
    <OnboardingSurface className="mx-auto max-w-2xl p-8 shadow-md">
      <div className="flex flex-col items-center text-center">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
          <AlertTriangle className="h-7 w-7 text-amber-700" aria-hidden />
        </div>
        <h2 className="mb-3 text-xl font-bold text-brand">
          No organization access
        </h2>
        <p className="mb-4 max-w-lg text-sm leading-relaxed text-gray-600">
          Your account is signed in but is not assigned to any organization. You
          cannot create projects, view runs, or manage users until an Admin
          invites you to an organization.
        </p>
        {email ? (
          <p className="mb-6 text-sm text-gray-500">
            Signed in as{' '}
            <span className="font-medium text-gray-700">{email}</span>
          </p>
        ) : null}
        <div className="w-full rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
          Contact an Admin to request access. They can re-invite you from{' '}
          <span className="font-medium">User Creation</span> using this email
          address.
        </div>
      </div>
    </OnboardingSurface>
  );
}

export default OrphanOrgAccessPanel;
